const MAX_CONSECUTIVE_STATUS_FAILURES = 3;

export const EXTRACTION_STATUS_UNAVAILABLE_MESSAGE =
  "We couldn't reconnect to the extraction status. Retry the status check, " +
  "or continue accessioning manually.";

export interface ExtractionStatusPollingState {
  jobId: string | null;
  consecutiveFailures: number;
  statusUnavailable: boolean;
}

export function createExtractionStatusPollingState(
  jobId: string | null = null
): ExtractionStatusPollingState {
  return { jobId, consecutiveFailures: 0, statusUnavailable: false };
}

export function isCurrentExtractionStatusJob(
  state: ExtractionStatusPollingState,
  jobId: string
): boolean {
  return state.jobId === jobId;
}

export function getFailedExtractionStepKeys(
  steps: Record<string, { status: string }> | undefined
): string[] {
  if (!steps) return [];
  return Object.entries(steps)
    .filter(([, step]) => step.status === "failed")
    .map(([stepKey]) => stepKey);
}

export function recordExtractionStatusSuccess(
  state: ExtractionStatusPollingState
): ExtractionStatusPollingState {
  return { ...state, consecutiveFailures: 0, statusUnavailable: false };
}

export function recordExtractionStatusFailure(
  state: ExtractionStatusPollingState
): ExtractionStatusPollingState {
  const consecutiveFailures = state.consecutiveFailures + 1;
  return {
    ...state,
    consecutiveFailures,
    statusUnavailable: consecutiveFailures >= MAX_CONSECUTIVE_STATUS_FAILURES,
  };
}

export function resumeExtractionStatusPolling(
  state: ExtractionStatusPollingState
): ExtractionStatusPollingState {
  return createExtractionStatusPollingState(state.jobId);
}
